<script>
export default {
  props: {
    message: {
      type: [String, Object],
      required: true,
    },
  },
  data: () => ({
    dismissed: false,
  }),
  mounted() {
    const component = this

    $(this.$refs['toast'])
      .toast({ delay: 2000 })
      .on('hidden.bs.toast', () => {
        component.dismissed = true
      })
      .toast('show')
  },
  computed: {
    messageContent() {
      return typeof this.message === 'string' ? this.message : this.message.message
    },
  },
}
</script>
<template>
  <div
    v-if="!dismissed"
    ref="toast"
    class="toast hide"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
    style="margin-bottom: 4rem"
  >
    <div class="toast-body">{{ messageContent }}</div>
  </div>
</template>
